'use client';
import { styled } from '@mui/material/styles';
import isPropValid from '@emotion/is-prop-valid';
import { FlexDirection } from '@repo/ui/src/types';
import {
  primaryFontFamily,
  warm,
} from '@style/variables.js';

const bulletSize = '32px';

interface MarkdownProps {
  flexDisplay: FlexDirection;
  smAndDown: boolean;
}

export const ToutContentWithMarkdownContainer = styled('div', {
  shouldForwardProp: isPropValid,
})<MarkdownProps>`
  .split {
    display: flex;
    flex-direction: ${(props) => props.flexDisplay || (props.smAndDown ? 'column' : 'row')};
    justify-content: space-between;
  }

  .content {
    padding-bottom: 1rem;
    max-width: 36rem;
    ${(props) => props.theme.breakpoints.up('md')} {
      padding-right: 4rem;
    }
    ${(props) => props.theme.breakpoints.up('lg')} {
      max-width: 40vw;
    }
  }

  .markdown {
    min-width: 30vw;

    ${(props) => props.theme.breakpoints.up('xl')} {
      min-width: 40vw;
    }
    ol {
      list-style: none;
      counter-reset: list-counter;
      margin: 0;
      padding-top: 0.5rem;

      li {
        counter-increment: list-counter;
        padding-bottom: 1rem;
        position: relative;
        line-height: ${bulletSize};
        font-weight: bold;
        font-family: ${primaryFontFamily};
      }
      li::before {
        content: counter(list-counter);
        color: ${warm};
        font-weight: bold;
        line-height: ${bulletSize};
        background: white;
        border-radius: 50%;
        width: ${bulletSize};
        height: ${bulletSize};
        margin-right: 0.5rem;
        position: absolute;
        top: 0;
        left: calc(-1 * ${bulletSize} - 10px);
        text-align: center;
      }
    }
  }
`;